export enum MethodRequest {
	Get = "Get",
	Post = "Post",
	Delete = "Delete",
	Put = "Put",
}
